import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Droplets } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { REGISTER } from "@/constants/testIds";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Password tidak cocok");
      return;
    }
    setSubmitting(true);
    try {
      await register(name, email, password);
      toast.success("Pendaftaran berhasil");
      navigate("/", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-grain">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-9 h-9 rounded-md bg-primary flex items-center justify-center">
            <Droplets className="w-5 h-5 text-primary-foreground" />
          </div>
          <div className="font-display font-bold text-xl">CINNABIT</div>
        </div>
        <div className="overline text-primary mb-3">Akun baru</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Daftar pengguna</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Sudah punya akun?{" "}
          <Link to="/login" className="text-primary underline-offset-4 hover:underline" data-testid={REGISTER.loginLink}>
            Masuk
          </Link>
        </p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">Nama</Label>
            <Input id="name" value={name} onChange={(e) => setName(e.target.value)} data-testid={REGISTER.nameInput} required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid={REGISTER.emailInput} required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid={REGISTER.passwordInput} required minLength={6} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="confirm">Konfirmasi Password</Label>
            <Input id="confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid={REGISTER.passwordConfirmInput} required minLength={6} />
          </div>
          {error && (
            <div className="text-sm text-destructive border border-destructive/30 bg-destructive/5 rounded-md px-3 py-2">{error}</div>
          )}
          <Button type="submit" className="w-full" disabled={submitting} data-testid={REGISTER.submitButton}>
            {submitting ? "Mendaftar…" : "Daftar"}
          </Button>
        </form>
      </div>
    </div>
  );
}
